import InputPrecursorTableRow from './InputPrecursorTableRow'
import { Table, TableColumnHeader, TableRow } from '@/common'
import { useTranslation } from 'react-i18next'
import { PrecursorMaterialWithPrecursorEmissionReport } from '@/hooks/api/v2/precursorMaterials'

export default function InputPrecursorTable({
  precursorMaterials,
  isViewMode,
  onEdit,
  installationId,
  emissionReportId,
  methodEmissionReportId
}: {
  precursorMaterials: PrecursorMaterialWithPrecursorEmissionReport[]
  isViewMode: boolean
  onEdit: (precursorMaterialId: string) => void
  installationId: string
  emissionReportId: string
  methodEmissionReportId: string
}) {
  const { t } = useTranslation()

  return (
    <div className="overflow-x-auto w-full">
      <Table className="text-sm">
        <thead>
          <TableRow>
            <TableColumnHeader className="w-56">
              {t('report:precursors.table.headers.source')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:precursors.table.headers.goodsCode')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:precursors.table.headers.goodsDescription')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:precursors.table.headers.internalId')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:precursors.table.headers.evidence')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:precursors.table.headers.specificDirectEmissions')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:precursors.table.headers.specificIndirectEmissions')}
            </TableColumnHeader>
            <TableColumnHeader className="w-24">
              {t('report:precursors.table.headers.quantity')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32" />
          </TableRow>
        </thead>
        <tbody>
          {precursorMaterials.map(item => (
            <InputPrecursorTableRow
              emissionReportId={emissionReportId}
              methodEmissionReportId={methodEmissionReportId}
              isViewMode={isViewMode}
              precursor={item}
              precursorEmissionReport={item.precursorEmissionReport}
              key={item.id}
              onEdit={onEdit}
              installationId={installationId}
            />
          ))}
        </tbody>
      </Table>
    </div>
  )
}
